import React, { useEffect, useRef, useCallback, useState, useMemo } from 'react';
import './BrowserTop.css';
import { f_isSignInWithEmailLink, f_signInWithEmailLink, auth } from '../Util/Firebase';
import { useNavigate, useLocation } from 'react-router-dom';
import AddAccess from '../Util/AddAccess';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { isAuthAtom, topMessageAtom, isAuthLoadedAtom } from '../../State';
import { ReactComponent as CopyLinkSVG } from '../Images/buttons/linkCopyGray.svg';
import { ReactComponent as HatenaSVG } from '../Images/buttons/hatenaButton.svg';
import { ReactComponent as DotsSVG } from '../Images/buttons/topdots.svg';
import { ReactComponent as InfinieSVG } from '../Images/buttons/infiniteMeetingIcon.svg';
import { ReactComponent as MeetingSVG } from '../Images/buttons/newMeeting.svg';
import { ReactComponent as LiveSVG } from '../Images/buttons/newLive.svg';
import { ReactComponent as JoinSVG } from '../Images/buttons/join.svg';
import { ReactComponent as TrashSVG } from '../Images/buttons/Trash.svg';
import { ReactComponent as LiveLeftSVG } from '../Images/buttons/liveLeftIcon.svg';
import { ReactComponent as EditSVG } from '../Images/buttons/edit.svg';
import { ReactComponent as ScheduleSVG } from '../Images/buttons/scheduleIcon.svg';
import { ReactComponent as ChangeSVG } from '../Images/buttons/changeIcon.svg';
import DataModel from '../Util/DataModel';
import Loading from '../Loading/Loading';
import { format } from 'date-fns';

export default function ListItem({
  meeting,
  callReload,
  setShowLiveState,
  setRoomID,
  setShowError,
  setMeetingIDState,
}) {
  const navigate = useNavigate(); //リダイレクト用
  const { t, i18n } = useTranslation();

  //Recoil系
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const [isAuthLoadedState, setIsAuthLoadedState] = useRecoilState(isAuthLoadedAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);
  const [isLoadedState, setIsLoadedState] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [leftDate, setLeftDate] = useState(0);
  const [unlimitedStatus, setUnlimitedStatus] = useState(false);
  const [hatenaState2, setHatenaState2] = useState(false);

  //ルートから
  const location = useLocation();
  const [comefromExitState, setComeFromExitState] = useState(location.state);

  useEffect(() => {
    if (meeting.liveDate != null) {
      //開始時間
      let date = new Date(meeting.liveDate?._seconds * 1000);

      let formatDate;
      if (i18n.language == 'ja') {
        formatDate = format(
          date,
          'MM' + '月' + 'dd' + '日 ' + 'h' + '時' + 'mm' + '分 ' + 'a' + ' ',
        );
      } else {
        formatDate = format(date, 'MMM do hh:mm a');
      }

      setStartDate(formatDate);
    } else {
      if (meeting.unlimited != null) {
        if (meeting.unlimited == false) {
          let currentDate = new Date();
          let createdDate = new Date(meeting.createdTime?._seconds * 1000);
          let diff = currentDate - createdDate;
          let diffDay = 7 - parseInt(diff / 1000 / 60 / 60 / 24);

          if (i18n.language == 'ja') {
            setLeftDate(String(diffDay) + '日後に削除');
          } else {
            let d = diffDay == 0 || diffDay == 1 ? ' day' : ' days';
            setLeftDate('Expires in ' + String(diffDay) + d);
          }

          setUnlimitedStatus(false);
        } else {
          setUnlimitedStatus(true);
        }
      }
    }
  }, []);

  //新しいミーティング
  const joinMeeting = async (e) => {
    // e.stopPropagation();
    navigate('/' + meeting.roomName);
  };

  //ライブの詳細を表示
  const showLiveDetail = async (e) => {
    setRoomID(meeting.roomName);
    setShowLiveState('detail');
    setShowMore(false);
  };

  //ライブの編集
  const editLiveDetail = async () => {
    setRoomID(meeting.roomName);
    setShowLiveState('edit');
    setShowMore(false);
  };

  //ミーティングの編集
  const editMeetingDetail = async () => {
    setRoomID(meeting.roomName);
    setShowLiveState('editMeeting');
    setShowMore(false);
  };

  //ミーティングURLを変更
  const changeMeetingURL = async () => {
    setIsLoadedState(true);
    let result = await DataModel.editMeeting(meeting.roomName, 'changeURL');
    if (result != null) {
      if (result.meetingID != null) {
        //ローカルストレージに保存
        localStorage.setItem('meetingID', result.meetingID);

        //ミーティングIDを設定
        setMeetingIDState(result.meetingID);

        //メッセージ
        setTopMessageState({ type: 'copied', message: t('mypage.Saved!') });
      }
    } else {
      setTopMessageState({ type: 'copied', message: t('mypage.Error something wrong') });
    }
    setIsLoadedState(false);
    setShowMore(false);
  };

  //無期限に変更
  const changeToUnlimited = async (e) => {
    e.stopPropagation();
    setShowMore(false);
    let result = await DataModel.editMeeting(meeting.roomName, 'unlimited');
    if (result != null) {
      if (result.status == 'already exist') {
        setShowError('unlimited');
      } else {
        setTopMessageState({ type: 'copied', message: t('mypage.Made it unlimited successfully') });
        callReload();
      }
    } else {
      setTopMessageState({ type: 'copied', message: t('mypage.Error something wrong') });
    }
    setShowMore(false);
  };

  //クリップボードにコピー
  const copyURL = (e) => {
    e.stopPropagation();
    let url;
    if (meeting.roomType == 'live') {
      url = 'https://faceless.ooo/l/' + meeting.roomName;
    } else {
      url = 'https://faceless.ooo/' + meeting.roomName;
    }

    navigator.clipboard.writeText(url).then(
      function () {
        setTopMessageState({ type: 'copied', message: t('top.Copied Successfully') });
      },
      function (err) {},
    );
    setShowMore(false);
  };

  //削除
  const deleteMeeting = async (e) => {
    e.stopPropagation();

    // 「はい」を選択した場合
    if (window.confirm(t('mypage.Do you want to delete it?'))) {
      console.log('「はい」を選択しました。');

      // 「いいえ」を選択した場合
    } else {
      console.log('「いいえ」を選択しました。');
      return;
    }

    setShowMore(false);

    let result = await DataModel.editMeeting(meeting.roomName, 'delete');
    if (result != null) {
      setTopMessageState({ type: 'copied', message: t('mypage.Deleted Successfully') });
      callReload();
      setShowMore(false);
    } else {
      setTopMessageState({ type: 'copied', message: t('mypage.Error something wrong') });
    }
  };

  //もっとを選択
  const showMoreNow = (e) => {
    e.stopPropagation();
    setShowMore(true);
  };

  const hatenaOver2 = async () => {
    setHatenaState2(true);
  };

  const hatenaOut2 = async () => {
    setHatenaState2(false);
  };

  return (
    <>
      {/*ローディング中*/}
      <div className="isElectron">
        <Loading loadingState={isLoadedState} />
      </div>

      {/* マイルーム */}
      {meeting.roomType == 'personal' && (
        <>
          <div className="listItemWrap2" onClick={joinMeeting}>
            {hatenaState2 && (
              <div className="listItemHatena">{t('mypage.Share this url for speaker...')}</div>
            )}

            <div className="listItemBody">
              <div className="listItemCategory">
                {t('mypage.My meeting room')}
                {/* <div
                  className="electronHatena"
                  onMouseEnter={hatenaOver2}
                  onMouseLeave={hatenaOut2}>
                  <HatenaSVG />
                </div> */}
              </div>
              <div className="listItemTitle">
                {meeting.liveTitle == null ? 'faceless.ooo/' + meeting.roomName : meeting.liveTitle}
              </div>
            </div>
            <div className="listItemCopy" onClick={copyURL}>
              <CopyLinkSVG />
            </div>
            <div className="listItemMore" onClick={showMoreNow}>
              <DotsSVG />
            </div>
          </div>
          {/* ３ドット */}
          {showMore && (
            <>
              <div className="addAreaBack" onClick={() => setShowMore(false)}></div>
              <div className="moreAreaWrap">
                <div className="moreAreaItem" onClick={joinMeeting}>
                  <JoinSVG />
                  <div>{t('mypage.Join Now')}</div>
                </div>

                <div className="moreAreaItem" onClick={copyURL}>
                  <CopyLinkSVG />
                  <div>{t('mypage.Copy URL')}</div>
                </div>

                <div className="moreAreaItem" onClick={changeMeetingURL}>
                  <ChangeSVG />
                  <div> {t('mypage.Change URL')}</div>
                </div>
              </div>
            </>
          )}
        </>
      )}

      {/* 通常ミーティング */}
      {meeting.roomType == 'private' && (
        <>
          <div className="listItemWrap" onClick={joinMeeting}>
            <div className="listItemIcon">
              {meeting.liveDate == null ? <InfinieSVG /> : <ScheduleSVG />}
            </div>
            <div className="listItemBody">
              <div className="listItemCategory">
                {meeting.liveDate == null ? t('mypage.My meeting') : startDate}
                {/* <span>（{unlimitedStatus ? t('mypage.Unlimited') : leftDate}）</span> */}
              </div>
              <div className="listItemTitle">
                {meeting.liveTitle == null ? 'faceless.ooo/' + meeting.roomName : meeting.liveTitle}
              </div>
            </div>
            <div className="listItemCopy" onClick={copyURL}>
              <CopyLinkSVG />
            </div>
            <div className="listItemMore" onClick={showMoreNow}>
              <DotsSVG />
            </div>
          </div>
          {/* ３ドット */}
          {showMore && (
            <>
              <div className="addAreaBack" onClick={() => setShowMore(false)}></div>
              <div className="moreAreaWrap">
                <div className="moreAreaItem" onClick={joinMeeting}>
                  <JoinSVG />
                  <div>{t('mypage.Join Now')}</div>
                </div>

                <div className="moreAreaItem" onClick={copyURL}>
                  <CopyLinkSVG />
                  <div>{t('mypage.Copy URL')}</div>
                </div>

                {/* {unlimitedStatus == false && (
                  <div className="moreAreaItem" onClick={changeToUnlimited}>
                    <UnlimitedSVG />
                    <div>{t('mypage.Make it unlimited')}</div>
                  </div>
                )} */}

                {meeting.roomType == 'personal' && (
                  <div className="moreAreaItem" onClick={changeMeetingURL}>
                    <ChangeSVG />
                    <div> {t('mypage.Change URL')}</div>
                  </div>
                )}

                {meeting.roomType != 'personal' && (
                  <div className="moreAreaItem" onClick={editMeetingDetail}>
                    <EditSVG />
                    <div> {t('mypage.Edit')}</div>
                  </div>
                )}

                {meeting.roomType != 'personal' && (
                  <div className="moreAreaItem" onClick={deleteMeeting}>
                    <TrashSVG />
                    <div style={{ color: '#FF0000' }}> {t('mypage.Delete')}</div>
                  </div>
                )}
              </div>
            </>
          )}
        </>
      )}

      {/* ライブ */}
      {meeting.roomType == 'live' && (
        <>
          <div className="listItemWrap" onClick={showLiveDetail}>
            <div className="listItemIcon">
              <LiveLeftSVG />
            </div>
            <div className="listItemBody">
              <div className="listItemCategory">{startDate} </div>
              <div className="listItemTitle">{meeting.liveTitle}</div>
            </div>
            <div className="listItemCopy"></div>
            <div className="listItemMore" onClick={showMoreNow}>
              <DotsSVG />
            </div>
          </div>
          {/* ３ドット */}
          {showMore && (
            <>
              <div className="addAreaBack" onClick={() => setShowMore(false)}></div>
              <div className="moreAreaWrap">
                <div className="moreAreaItem" onClick={showLiveDetail}>
                  <JoinSVG />
                  <div> {t('mypage.Detail')}</div>
                </div>

                <div className="moreAreaItem" onClick={editLiveDetail}>
                  <EditSVG />
                  <div> {t('mypage.Edit')}</div>
                </div>

                <div className="moreAreaItem" onClick={deleteMeeting}>
                  <TrashSVG />
                  <div style={{ color: '#FF0000' }}> {t('mypage.Delete')}</div>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
}
